import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

const pikaday = require('pikaday');
const moment = require('moment');

import 'pikaday/css/pikaday.css'
// import i18n from './i18n'

let i18n_picker = {
    previousMonth: 'Mes Anterior',
    nextMonth: 'Siguiente Mes',
    months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto',
        'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    weekdays: ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sábado'],
    weekdaysShort: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab']
};

Object.defineProperty(Vue.prototype, '$pikaday', {value: pikaday});
Object.defineProperty(Vue.prototype, '$moment', {value: moment});
Object.defineProperty(Vue.prototype, '$i18n_picker', {value: i18n_picker});

Object.defineProperty(Vue.prototype, '$outQuinticFn', {
    value: function (t, b, c, d) {
        var ts = (t /= d) * t;
        var tc = ts * t;
        return b + c * (tc * ts + -5 * ts * ts + 10 * tc + -10 * ts + 5 * t);
    }
});

Vue.config.productionTip = false;

// if (localStorage.getItem('lang') === null) {
//     localStorage.setItem('lang', 'es')
// }

new Vue({
    router,
    store,
    // i18n,
    render: h => h(App)
}).$mount('#app')
